export const DATA_PLATFORM_BACKGROUND_COLOR = "#F5F5F5";
export const DATA_PLATFORM_GRAY_COLOR = "#C4C4C4";
export const DATA_PLATFORM_GREEN_COLOR = "#2E9B66";
export const DATA_PLATFORM_YELLOW_COLOR = "#F5E980";
export const DATA_PLATFORM_RED_COLOR = "#EF6565";

export const DATA_PLATFORM_RED_GRAY = "#595959";
export const DATA_PLATFORM_YELLOW_GRAY = "#8B8B8B";
export const DATA_PLATFORM_GREEN_GRAY = "#D3D3D3";
